import React, { useState } from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/PlaceOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import StoreSelectorModal from '../../redux/containers/store/StoreSelectorModal';

export default function StoreSelector({ loading, currentChain, currentStoreName }) {
  const [open, setOpen] = useState(false);

  // Strip store code prefix (e.g. "SC011 - Easy La Reina" → "Easy La Reina")
  const displayName = currentStoreName?.split(' - ').slice(1).join(' - ') || currentStoreName;

  if (loading) return <Skeleton variant="text" width={180} height={32} />;

  return (
    <>
      {/* Clickable row: chain + store name — opens the store selector modal */}
      <Box
        onClick={() => setOpen(true)}
        sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer' }}
      >
        <LocationOnIcon sx={{ fontSize: 22, mb: '4px', color: 'error.main' }} />
        <Typography variant="subtitle1" fontWeight={700} noWrap>
          {currentChain}, {displayName}
        </Typography>
        <KeyboardArrowDownIcon sx={{ fontSize: 20 }} />
      </Box>

      <StoreSelectorModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
